import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { AppLinkSource } from 'sources'

@createActions(alt)
export default class AppLinkActions {
  constructor() {
    this.generateActions(
      'setLink',
      'setErrored'
    )
  }

  getLink(id, resource, onFetched) {
    this.setErrored(false)
    return AppLinkSource.fetchLink(id, resource)
      .then(resp => {
        this.setLink(resp)
        if (onFetched)
          onFetched(resp)
      })
      .catch(error => {
        this.setErrored(true)
      })
  }
}



// WEBPACK FOOTER //
// ./app/actions/AppLinkActions.js